export default "__VITE_ASSET__BYMJ50WK__"